import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import { motion } from "framer-motion";
import { BLOG } from "@/constants/testIds";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    axios
      .get(`${API}/blog/${slug}`)
      .then((r) => setPost(r.data))
      .catch(() => setNotFound(true));
    window.scrollTo(0, 0);
  }, [slug]);

  if (notFound) {
    return (
      <div className="pt-40 pb-32 max-w-[800px] mx-auto px-6 text-center">
        <h1 className="font-serif text-5xl">Post not found.</h1>
        <Link to="/#journal" data-testid={BLOG.back} className="eyebrow link-underline mt-8 inline-block">
          ← Back to Journal
        </Link>
      </div>
    );
  }

  if (!post) {
    return <div className="pt-40 pb-32 text-center eyebrow">Loading…</div>;
  }

  return (
    <article className="pt-32 pb-24">
      <div className="max-w-[900px] mx-auto px-6 md:px-12">
        <Link to="/#journal" data-testid={BLOG.back} className="eyebrow link-underline">
          ← Back to Journal
        </Link>

        <motion.header
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="mt-8"
        >
          <p className="eyebrow mb-6">{post.date} · {post.read_time}</p>
          <h1 className="font-serif text-5xl md:text-7xl leading-[1.02] tracking-tight">
            {post.title}
          </h1>
        </motion.header>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="mt-12 overflow-hidden"
        >
          <img src={post.image} alt={post.title} className="w-full h-[60vh] object-cover" />
        </motion.div>

        <div className="prose-custom mt-12 max-w-[680px] mx-auto space-y-6 font-serif text-2xl leading-[1.45] text-ink/85">
          {post.body.split("\n\n").map((para, i) => (
            <p key={i}>{para}</p>
          ))}
        </div>

        <div className="mt-20 border-t hairline pt-8 max-w-[680px] mx-auto">
          <Link to="/#journal" className="eyebrow link-underline">
            ← Back to all essays
          </Link>
        </div>
      </div>
    </article>
  );
}
